import { IWithChildren } from 'types';
import classNames from 'classnames';
import styles from './styles.module.scss';

export const MetricBox = (
  {
    children, className, title, link,
  }: IWithChildren & { className?: string, title?: string, link?: React.ReactNode },
) => (
  <article className={classNames(styles.box, className)}>
    {title && (<h3 className={styles.title}>{title}</h3>)}
    {link && <div className={styles.topRight}>{link}</div>}
    {children}
  </article>
);
